module.exports = __webpack_public_path__ + "static/img/r2-4.7812a20.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/zh/r2-4.png
// module id = EeTZ
// module chunks = 1